import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { endRubberline, stepBackRubberLine } from "../../../store/interaction";
import { hitStrokeCorrection, strokeCorrection } from "../util/strokeCorrection";
import { insertShape } from "../../../store/model";
import BasePolygon from "../shapes/polygon/PolygonBase";
import { useSnapMousePosition } from "./useSnapMousePosition";
import { RootState } from "../../../store/store";
import { useCallback, useEffect, useMemo } from "react";
import { recalculateShape } from "../util/shapeEdit";

const PolygonRubber = () => {
  const dispatch = useAppDispatch();
  const interaction = useAppSelector((state: RootState) => state.interaction)
  const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
  const defaultSetting = useAppSelector((state: RootState) => state.tool.toolSettings.polygon.current);
  const mousePositionSnap = useSnapMousePosition();

  const rubberpolygonLength = interaction.rubberlineData.snapPoints.length;
  const rubberpolygon = interaction.rubberlineData.snapPoints;
  const rubberpolygonPointer = interaction.rubberlineData.pointerPoints;
  const editState = interaction.editorState;
  const SAMEPOINT_DISTANCE = 10;

  const internalProperties = useMemo(() => {
    return {
      ...defaultSetting,
      id: 0,
      strokeWidth: strokeCorrection(defaultSetting.strokeWidth, scale),
      points: interaction.rubberlineData.snapPoints.concat(mousePositionSnap),
      hitStrokeWidth: hitStrokeCorrection(defaultSetting.hitStrokeWidth, defaultSetting.hitStrokeWidth, scale),
      closed: false,
    }
  }, [defaultSetting, interaction.rubberlineData.snapPoints, mousePositionSnap, scale])

  const clickedSamePoint = useCallback(() => {
    return rubberpolygonLength >= 2 ? (
      (Math.abs(rubberpolygonPointer[rubberpolygonLength - 1].x - rubberpolygon[rubberpolygonLength - 2].x) < (SAMEPOINT_DISTANCE / scale)) &&
      (Math.abs(rubberpolygonPointer[rubberpolygonLength - 1].y - rubberpolygon[rubberpolygonLength - 2].y) < (SAMEPOINT_DISTANCE / scale))
    ) : false
  }, [rubberpolygonLength, rubberpolygonPointer, rubberpolygon, scale])

  const finishRubberpolygon = useCallback(function () {
    let validPointOfLine = clickedSamePoint()
      ? interaction.rubberlineData.snapPoints.filter((_x, i) => i < (rubberpolygonLength - 1))
      : interaction.rubberlineData.snapPoints;

    dispatch(insertShape(
      recalculateShape(assembleShapeToInsert<PolygonShape>({ ...internalProperties, points: validPointOfLine }),
      )))
    dispatch(endRubberline());
  }, [clickedSamePoint, dispatch, interaction.rubberlineData.snapPoints, internalProperties, rubberpolygonLength])

  useEffect(() => {
    const handleRubberPolygon = (e: KeyboardEvent) => {
      switch (e.key) {
        case "Backspace":
          if (editState === 'normal') {
            dispatch(stepBackRubberLine(1));
          }
          break;
        default:
          break;
      }
    }
    window.addEventListener("keydown", handleRubberPolygon);
    return () => window.removeEventListener("keydown", handleRubberPolygon);
  }, [dispatch, editState])

  if (rubberpolygonLength === 0) {
    //dispatch(setToolMessage("define start point"))
    return (
      <></>
    )
  }
  if (clickedSamePoint() && rubberpolygonLength >= 2) {
    finishRubberpolygon();
  } else {

    //dispatch(setToolMessage("define endpoint"))
    return (
      <BasePolygon shapeProps={internalProperties} />
    )
  }

  return <></>
}

function assembleShapeToInsert<L>(shape: L): L {
  return shape;
}
export const createPolygonRubber = () => {
  return <PolygonRubber />
};

export default PolygonRubber;